import { render, staticRenderFns } from "./ProblemModal.vue?vue&type=template&id=b5afa204"
import script from "./ProblemModal.vue?vue&type=script&lang=js"
export * from "./ProblemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports